/** 提交/API/库存储用 */
export const BORROW_SEAL_CERTIFICATE_ID = 0;
/** 下拉选项 value（避免 Ant Design Select 将 0 当 falsy） */
export const BORROW_SEAL_OPTION_VALUE = '__borrow_seal__';

export function isBorrowSealItem(item) {
  return item?.is_seal === true
    || item?.certificate_id === BORROW_SEAL_CERTIFICATE_ID
    || item?.certificate_id === '0'
    || item?.certificate_id === BORROW_SEAL_OPTION_VALUE
    || item?.value === BORROW_SEAL_OPTION_VALUE;
}

export function isBorrowSelectionValid(item) {
  if (!item?.company_id) return false;
  return isBorrowSealItem(item) || !!item.certificate_id;
}

export function toBorrowSealCertificateId(value) {
  return isBorrowSealItem({ certificate_id: value, is_seal: value === BORROW_SEAL_OPTION_VALUE })
    ? BORROW_SEAL_CERTIFICATE_ID
    : value;
}

export function isBorrowWatermarkEnabled(value) {
  return value === true || value === 1 || value === '1';
}

export function borrowCopyTypeLabel(cert) {
  if (isBorrowSealItem(cert)) return '';
  return cert?.copy_type_label || (cert?.copy_type === 'copy' ? '复印件' : '原件');
}

export function resolveBorrowPreviewWatermark(cert, previewMeta) {
  if (isBorrowSealItem(cert)) {
    return { applyWatermark: false, watermarkText: '' };
  }
  const watermarkText = String(previewMeta?.watermark_text || cert?.watermark_text || '').trim();
  const isCopy = (cert?.copy_type || previewMeta?.copy_type) === 'copy';
  const needWatermark = previewMeta?.watermark === true || isBorrowWatermarkEnabled(cert?.need_watermark);
  const applyWatermark = isCopy && needWatermark && !!watermarkText;
  return { applyWatermark, watermarkText };
}

export function buildSealCertOption() {
  return {
    value: BORROW_SEAL_OPTION_VALUE,
    label: '公章',
    cert_name: '公章',
    is_seal: true
  };
}

export function appendSealCertOption(options = []) {
  if (options.some((opt) => isBorrowSealItem(opt))) return options;
  return [...options, buildSealCertOption()];
}

/** Select 回显：库存 0 → 选项 value */
export function toBorrowSealOptionValue(certificateId) {
  return isBorrowSealItem({ certificate_id: certificateId }) ? BORROW_SEAL_OPTION_VALUE : certificateId;
}
